import { Component, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'address',
  templateUrl: './address.component.html',
})
export class AddressComponent {
  @Input() required: boolean = true;
  @Input() states: Array<string> = [];
  @Input() addressLine1: string;
  @Input() addressLine2: string;
  @Input() city: string;
  @Input() state: string;
  @Input() zip: string;

  @Output() addressLine1Change = new EventEmitter<string>();
  @Output() addressLine2Change = new EventEmitter<string>();
  @Output() cityChange = new EventEmitter<string>();
  @Output() stateChange = new EventEmitter<string>();
  @Output() zipChange = new EventEmitter<string>();

  @ViewChild(NgForm) form;


  constructor() { }

}
